import { LineString } from 'geojson';

import { SubTrajectorySegment } from './subtrajectorysegment.model';

export class Fcd {
  originalID: string;
  internalID: string;
  fingerprintID: string;
  trajectoryFreeFlowSpeed: number;
  subTrajectorySegments: SubTrajectorySegment[];
  fcdMatchConfidence?: number;
  fcdMatchGeometry?: string | LineString;
}



// WEBPACK FOOTER //
// ./src/app/models/fcd/fcd.model.ts